import { lazy, Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';

import ErrorBoundaryContainer from '../../components/ErrorBoundaryContainer';
import Loading from '../../components/Loading';

import accountRouter from '../account';

const DashboardPageComponent = lazy(
  () => import(/* webpackChunkName: "dashboard" */ '../../pages/dashboard'),
);

const ProjectInformationDialogComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "project" */ '../../pages/project/ProjectInformationDialog'
    ),
);

const mainDahboardRouter = (
  <Route path="dashboard" element={<Outlet />}>
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <ErrorBoundaryContainer
            key="dashboard"
            component={<DashboardPageComponent />}
          />
        </Suspense>
      }
    >
      <Route
        path="info"
        element={
          <ErrorBoundaryContainer
            key="project-info"
            component={<ProjectInformationDialogComponent mode="view" />}
          />
        }
      />
      {accountRouter()}
    </Route>
  </Route>
);

export default mainDahboardRouter;
